
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Signup = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect to new auth gateway
    navigate('/auth', { replace: true })
  }, [navigate])

  return null
}

export default Signup

/*
// LEGACY CODE - Replaced by AuthGateway + RoleSelect + OnboardingStepper flow
// Keeping for reference only

import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-hot-toast'
import {ArrowRight, ArrowLeft, CheckCircle, User, Briefcase} from 'lucide-react'
import { lumi } from '../lib/lumi'

interface SignupFormData {
  // Step A - Account
  fullName: string
  email: string
  password: string
  country: string
  
  // Step B - Profile
  educationLevel: string
  yearsExperience: number
  specialties: string[]
  destinationTrack: string[]
  nclexStatus: string
  cgfnsStatus: string
  dataflowStatus: string
  englishStatus: string
  consent: boolean
}

const SignupLegacy = () => {
*/
